<template>
  <div v-if="frame" class="textbox-tag">
    <div class="textbox" :class="sizeClz" ref="textContent" v-bind:style=[styleObj] v-html="rawHtml" @click="onClick">
    </div>
  </div>
</template>
<script>

import marked from 'marked'
import { boxSizes, tAligns, hAligns, vAligns, whiteColor, blackColor } from './utils'
import { base } from './mixins/multilang'
import { analytics } from './mixins/analytics/'

export default {
  name: 'textbox',
  props: ['meta', 'frame', 'isLastFrame', 'dimensions'],
  mixins: [base, analytics],
  created() {
    this.initTag()
  },
  mounted() {
    /*
    this.links = this.$refs.textContent.getElementsByTagName("a")
    console.log('textbox mounted: links', this.links)
    for (var i = 0; i < this.links.length; i++) {
      this.links[i].addEventListener('click', this.onLinkClicked)
    }
    */
  },
  beforeDestroy() {
    if (this.links) {
      for (var i = 0; i < this.links.length; i++) {
        this.links[i].removeEventListener('click', this.onLinkClicked)
      }
    }
  },
  watch: {
    'meta': 'initTag',
    'selectedLanguage': 'selectedLanguageChanged',
    isLastFrame(isLast) {
      console.log('hotSpotTag isLastFrame %s. current frame %v', isLast, this.frame)
      if (isLast && this.onLastFrame.action !== 'none') {
        this.$emit('videoaction', this.onLastFrame)
      }
    }
  },
  data() {
    return {
      videoElement: null,
      rawHtml: null,
      bgColor: null,
      color: null,
      tAlign: null,
      alignement: null,
      vAlignement: null,
      fontBaseSize: 12,
      fontWeight: 400,
      borderRadius: 0,
      boxShadow: 0
    }
  },
  computed: {
    styleObj: function() {
      let bg = this.bgColor
      let clr = this.color
      let w = this.frame.pw * this.dimensions.w
      let h = this.frame.ph * this.dimensions.h
      let tAlign = this.tAlign
      // console.log('styleObj:', this.frame, this.dimensions, w, h, bg, clr)
      let so = {
        'width': w + 'px',
        'height': h + 'px',
        'margin-top': (-h / 2) + 'px',
        'margin-left': (-w / 2) + 'px',
        'color': `rgba(${clr.r}, ${clr.g}, ${clr.b}, ${clr.a})`,
        'background-color': `rgba(${bg.r}, ${bg.g}, ${bg.b}, ${bg.a})`,
        'text-align': `${tAlign}`,
        'cursor': this.behaviour.action !== undefined ? 'pointer' : '',
        "font-weight": this.fontWeight,
        "border-radius": this.borderRadius + "px",
        "display": "flex",
        "flex-direction": "column",
        "justify-content": this.vAlignement,
        "align-items": this.alignement
      }

      if (this.animation) {
        var a = this.animation
        let av = ''

        if (a.value) {
          av = `${a.animation} ${a.value || 2000}ms ${a.mode}`
        } else {
          av = `${a.animation} ${a.duration || 2}s infinite`
        }

        so['animation'] = av
      }

      if (this.scaleBehaviour === 'linear') {
        so.fontSize = `${this.dimensions.scaleFactorW * this.fontBaseSize}px`
      }

      // omit the property completely if set to 0
      if (this.boxShadow > 0) {
        so['box-shadow'] = `0px 0px ${this.boxShadow}px 0px rgba(0,0,0,0.25)`
      }

      return so
    },
    sizeClz: function() {
      if (this.scaleBehaviour !== 'linear') {
        return boxSizes[Math.floor(this.dimensions.w / 320)] || 12
      }
    }
  },
  methods: {
    initTag() {
      let val = this.meta.value
      let html = marked(val.markdown[this.selectedLanguage || val.markdown.lang]) // if no selected language default to the one on the multi lang object
      this.rawHtml = html
      this.bgColor = val.bgColor || whiteColor()
      this.color = val.color || blackColor()
      this.tAlign = tAligns[this.meta.textAlignement] || 'left'
      this.alignement = hAligns[this.meta.alignement] || 'flex-start'
      this.vAlignement = vAligns[this.meta.vAlignement] || 'flex-start'
      this.scaleBehaviour = (this.meta.scaleBehaviour || {}).scaleBehaviour || 'linear'
      this.onLastFrame = this.meta.onLastFrame || {}
      this.behaviour = this.meta.behaviour || {}
      this.fontBaseSize = this.meta.fontBaseSize || 12
      this.fontWeight = this.meta.fontWeight || 400
      this.borderRadius = this.meta.borderRadius || 0
      this.boxShadow = this.meta.boxShadow || 0
      this.animation = this.meta.animation
      console.log('textbox.inited', this.marked)
    },
    selectedLanguageChanged(newVal) {
      console.log("selectedLanguageChanged", newVal)
      if (!newVal) {
        return
      }
      this.rawHtml = marked(this.meta.value.markdown[newVal] || '')
    },
    onLinkClicked(e) {
      console.log('onLinkClicked', e)
      e.preventDefault();
    },
    onClick(ev) {
      this.trackTag("TextBox")
      this.$emit('action', this.behaviour)
    }
  }
}

</script>
